module.exports = __webpack_public_path__ + "static/img/footOneImg4.8582713.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footOneImg4.png
// module id = pW8l
// module chunks = 1